import { z } from 'zod';
import { TexteBilingueSchema } from './textes.js';
/**
 * Rubriques adressables du site. Un menu ne porte jamais un chemin écrit à la
 * main : il désigne une rubrique, et le moteur en fabrique le chemin dans la
 * langue rendue. C'est ce qui garantit qu'aucun lien de navigation ne meurt.
 */
export const RUBRIQUES = [
    'accueil',
    'artistes',
    'expositions',
    'foires',
    'oeuvres',
    'actualites',
    'la-galerie',
    'contact',
    'mentions',
    'confidentialite',
    'plan-du-site',
];
export const RubriqueSchema = z.enum(RUBRIQUES);
export const EntreeMenuSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('rubrique'),
        rubrique: RubriqueSchema,
        /** Libellé sur mesure ; à défaut, celui du moteur dans la langue rendue. */
        libelle: TexteBilingueSchema.optional(),
    }),
    z.object({
        type: z.literal('externe'),
        libelle: TexteBilingueSchema,
        url: z.url(),
    }),
]);
export const MenusSchema = z.object({
    principal: z.array(EntreeMenuSchema),
    pied: z.array(EntreeMenuSchema),
});
//# sourceMappingURL=menus.js.map